import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

const FormSectionCard = (props) => {
    const {
        action,
        children,
        hint,
        tight,
        title,
    } = props;
    const hasHeader = Boolean(title || action || hint);

    return (
        <Card
            elevation={0}
            sx={{
                backgroundColor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: '9px',
                overflow: 'visible',
            }}
        >
            {hasHeader ? (
                <Box
                    sx={{
                        alignItems: 'center',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        display: 'flex',
                        justifyContent: 'space-between',
                        minHeight: 42,
                        px: '14px',
                        py: '10px',
                    }}
                >
                    <Box>
                        {title ? (
                            <Typography
                                color="text.secondary"
                                sx={{
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    letterSpacing: '0.04em',
                                    textTransform: 'uppercase',
                                }}
                            >
                                {title}
                            </Typography>
                        ) : null}
                        {hint ? (
                            <Typography color="text.secondary" sx={{ fontSize: '11px', mt: '2px' }}>
                                {hint}
                            </Typography>
                        ) : null}
                    </Box>
                    {action}
                </Box>
            ) : null}
            <Box sx={{ px: '14px', py: tight ? '11px' : '14px' }}>
                {children}
            </Box>
        </Card>
    );
};

FormSectionCard.propTypes = {
    action: PropTypes.node,
    children: PropTypes.node,
    hint: PropTypes.node,
    tight: PropTypes.bool,
    title: PropTypes.node,
};

export default React.memo(FormSectionCard);
